import { WitaConnector } from '@/services/repository/connector'
import { FormDataHandler } from '@/utils/helpers/FormDataHandler'
import { querySerializer } from '@/utils/helpers/URLs'

import { Repo } from './CallEvidenceImage.d'

const ROOT_URL = '/entity/call-evidence-images'

export const CallEvidenceImageRepository = {
  Search: async (params: Repo.CallEvidenceImage.FindByCallId.Params) => {
    const url = ROOT_URL + `?${querySerializer(params)}`
    return await WitaConnector.get<Repo.CallEvidenceImage.FindByCallId.Response>(
      url,
    )
  },

  Create: async (params: Repo.CallEvidenceImage.Create.Params) => {
    const formData = FormDataHandler(params)
    const url = ROOT_URL
    return await WitaConnector.post<Repo.CallEvidenceImage.Create.Response>(
      url,
      formData,
    )
  },

  Delete: async ({ id }: Repo.CallEvidenceImage.Delete.Params) => {
    const url = ROOT_URL + `/${id}`
    return await WitaConnector.delete<Repo.CallEvidenceImage.Delete.Response>(
      url,
    )
  },
}
